import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.nav-container-luxhom')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = (e) => {
    e.stopPropagation();
    console.log('Hamburger clicked! Current state:', isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
    console.log('New state will be:', !isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`navbar-luxhom ${isScrolled ? 'scrolled' : ''}`} role="navigation" aria-label="Main navigation">
        <div className="container">
          <div className="nav-container-luxhom">
            <Link to="/" className="nav-logo-luxhom" onClick={() => setIsMobileMenuOpen(false)} aria-label="TrueHome Properties - Go to homepage">
              <img 
                src="/images/truehomelogo-removebg-preview.png" 
                alt="TrueHome Properties - Leading real estate company across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai" 
                className="logo-image"
                loading="eager"
              />
            </Link>
            
            <ul className={`nav-menu-luxhom ${isMobileMenuOpen ? 'active' : ''}`} role="menubar">
              <li role="none"><a href="#home" className="nav-link-luxhom" onClick={() => scrollToSection('home')} role="menuitem">Home</a></li>
              <li role="none"><a href="#properties" className="nav-link-luxhom" onClick={() => scrollToSection('properties')} role="menuitem">Properties</a></li>
              <li role="none"><a href="#services" className="nav-link-luxhom" onClick={() => scrollToSection('services')} role="menuitem">Services</a></li>
              <li role="none"><a href="#projects" className="nav-link-luxhom" onClick={() => scrollToSection('projects')} role="menuitem">Projects</a></li>
              <li role="none"><a href="#about" className="nav-link-luxhom" onClick={() => scrollToSection('about')} role="menuitem">About</a></li>
              <li role="none"><a href="#contact" className="nav-link-luxhom" onClick={() => scrollToSection('contact')} role="menuitem">Contact</a></li>
            </ul>
            
            <button 
              className={`hamburger-luxhom ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={isMobileMenuOpen}
              aria-controls="nav-menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>
      
      {/* Mobile Bottom Navigation - Only visible on mobile */}
      <nav className="mobile-bottom-nav" role="navigation" aria-label="Mobile bottom navigation">
        <a href="#home" className="mobile-nav-item" onClick={() => scrollToSection('home')} aria-label="Navigate to home section">
          <span className="mobile-nav-icon" aria-hidden="true">🏠</span>
          <span className="mobile-nav-label">Home</span>
        </a>
        <a href="#properties" className="mobile-nav-item" onClick={() => scrollToSection('properties')} aria-label="Navigate to properties section">
          <span className="mobile-nav-icon" aria-hidden="true">🏢</span>
          <span className="mobile-nav-label">Properties</span>
        </a>
        <a href="#services" className="mobile-nav-item" onClick={() => scrollToSection('services')} aria-label="Navigate to services section">
          <span className="mobile-nav-icon" aria-hidden="true">⚙️</span>
          <span className="mobile-nav-label">Services</span>
        </a>
        <a href="#projects" className="mobile-nav-item" onClick={() => scrollToSection('projects')} aria-label="Navigate to projects section">
          <span className="mobile-nav-icon" aria-hidden="true">📋</span>
          <span className="mobile-nav-label">Projects</span>
        </a>
        <a href="#about" className="mobile-nav-item" onClick={() => scrollToSection('about')} aria-label="Navigate to about section">
          <span className="mobile-nav-icon" aria-hidden="true">ℹ️</span>
          <span className="mobile-nav-label">About</span>
        </a>
        <a href="#contact" className="mobile-nav-item" onClick={() => scrollToSection('contact')} aria-label="Navigate to contact section">
          <span className="mobile-nav-icon" aria-hidden="true">📞</span>
          <span className="mobile-nav-label">Contact</span>
        </a>
      </nav>
    </>
  );
};

export default Navbar;